<template>
    <div>    
        <h4>{{data.Title}}</h4>
        <div class="row">
                <div class="col-7">
                    <span class="text-danger" v-show="!data.Title">{{translate('draftPreview.jobNameMustEnter')}}</span>
                    <table class="table table-borderless table-sm ozet">
                        <tbody>

                            <tr v-if="data.ReferenceJob">
                                <td style="width:1px">{{translate('draftPreview.revisedJob')}}</td>
                                <td>:</td>
                                <td>
                                    <router-link target="_blank" :to="{ name: 'JobMyDetail', params: { id : data.ReferenceJob.Id } }">
                                        {{data.ReferenceJob.TrackingNo | trackingNo}}
                                    </router-link> —
                                    {{data.ReferenceJob.Title}}
                                </td>
                            </tr>
                            <tr>
                                <td style="width:1px">{{translate('draftEyp.description')}}</td>
                                <td>:</td>
                                <td>{{data.Description}}</td>
                            </tr>
                            <tr v-if="data.DocumentNumber">
                                <td>{{translate('draft.docNo')}}</td>
                                <td>:</td>
                                <td>{{data.DocumentNumber}}</td>
                            </tr>
                            <tr>
                                <td style="white-space:nowrap" v-html="translate('draftPreview.targetEnd')"></td>
                                <td>:</td>
                                <td>
                                    {{data.TargetDate | date }}
                                    <i v-if="!data.TargetDate" class="text-muted">{{translate('draftPreview.targetEndNotDefined')}}</i>
                                </td>
                            </tr>
                            <tr>
                                <td>{{translate('draft.categories')}}</td>
                                <td>:</td>
                                <td><label class="badge" v-for="c in categories" :key="c.Id" style="margin-right:4px; background-color:#E1E1E1;">{{c.Name}}</label></td>
                            </tr>
                            <tr>
                                <td>{{translate('incomingDocFilter.docType')}}</td>
                                <td>:</td>
                                <td>{{docType | documentType}}</td>
                            </tr>
                            <tr v-if="docType == 'BankOrder'">
                                <td>{{translate('draft.orderAmount')}}</td>
                                <td>:</td>
                                <td>
                                 <span v-if="data.Amount">  {{data.Amount | money}}</span>
                                 
                                 <span v-if="data.Currency">   {{data.Currency}}</span>
                                  
                                    </td>
                            </tr>
                            <tr v-if="docType == 'Contract'">
                                <td>{{translate('draft.contractAmount')}}</td>
                                <td>:</td>
                                <td>
                                    <div class="input-group" >
                                        <input type="number" v-model.number="data.ContractAmount" class="form-control text-right" style="width: 100px; flex: none;" :placeholder="translate('draft.amount')">                                
                                        <select v-model="data.ContractCurrency" class="custom-select" style="max-width:70px;" :placeholder="translate('draft.currency')">
                                            <option label="₺" value="TRY" >₺</option>
                                            <option label="$" value="USD" >$</option>
                                            <option label="€" value="EUR" >€</option>
                                            <option label="£" value="GBP">£</option>
                                            <option label="¥" value="JPY">¥</option>
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="data.CirculationProfileSchema">
                                <td>{{translate('reportFilter.flow')}}</td>
                                <td>:</td>
                                <td>
                                    {{data.CirculationProfileSchema.Name}}
                                    <span class="text-danger" v-show="!data.CirculationProfileSchema.IsActive">({{translate('draftPreview.notActive')}})</span>
                                </td>
                            </tr>
                            <tr>
                                <td>{{translate('draft.docPrivacy')}}</td>
                                <td>:</td>
                                <td v-html="$options.filters.privacy(data.Privacy)"></td>
                            </tr>
                            <tr>
                                <td>{{translate('draftPreview.documentsToSign')}}</td>
                                <td>:</td>
                                <td style="padding:0">
                                    <table class="table table-sm table-borderless">
                                        <tbody>
                                            <tr style="font-weight:bold;">
                                                <td>{{(data.Documents || []).length}} {{translate('draftPreview.file')}}</td>
                                                <td class="text-right">{{translate('draft.sum')}}:</td>
                                                <td class="text-right">{{totalDocumentSize | prettyBytes}}</td>
                                            </tr>
                                            <tr v-for="d in data.Documents" :key="d.Id">
                                                <!-- <td><a title="İndir" href="#void" @click.prevent="downloadDocument(d)">{{d.File.FileName}}</a></td> -->
                                                <td><file-download-link  :isOnlineView="onlineViewEnabled" :document="d" @download="downloadDocument" @preview="showFilePreview" ></file-download-link></td>
                                                <td>{{d.SignatureFormat | signatureFormat}}</td>
                                                <td class="text-right">{{d.File.Size | prettyBytes}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="text-danger" v-show="!data.Documents || data.Documents.length == 0">
                                        {{translate('warnings.atLeastOneFileForCirculation')}}
                                    </div>
                                    <div class="alert alert-warning" v-if="totalDocumentSize && totalFileSizeLimit && totalDocumentSize > totalFileSizeLimit">
                                        {{translate('draftPreview.totalDocSize:' + totfileSizeLimit(totalFileSizeLimit))}}
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="data && data.Attachments && data.Attachments.length > 0">
                                <td>{{translate('draftPreview.attachmentFiles')}}</td>
                                <td>:</td>
                                <td style="padding:0">
                                    <table class="table table-sm table-borderless">
                                        <tbody>
                                            <tr style="font-weight:bold;">
                                                <td>
                                                    <div class="float-right">{{translate('draft.sum')}}:</div>
                                                    {{data.Attachments.length}} {{translate('draftPreview.file')}}
                                                </td>
                                                <td class="text-right">{{totalAttachmentSize | prettyBytes}}</td>
                                            </tr>
                                            <tr v-for="d in data.Attachments" :key="d.Id">
                                                <td><file-download-link  :isOnlineView="onlineViewEnabled" :document="d" @download="downloadAttachment" @preview="showAttachmentPreview" ></file-download-link></td>
                                                <td>{{d.SignatureFormat | signatureFormat}}</td>
                                                <td class="text-right">{{d.Size | prettyBytes}}</td>
                                            </tr>
                                        </tbody> 
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td v-if="(targetSystems && targetSystems.length)">{{translate('circulationProfileSchema.targetSystems')}}</td>
                                <td v-else>{{translate('remPreview.receiver')}}</td>
                                <td>:</td>
                                <td style="padding:0">
                                    <div class="text-danger" style="padding-top:4px" v-show="(!targetSystems || targetSystems.length == 0) && (!data.AdditionalTargetSystems || data.AdditionalTargetSystems.length == 0)">
                                        {{translate('errors.atLeastOneTargetSystem')}}
                                    </div>
                                    <table class="table table-hover table-borderless table-sm">
                                        <tbody>
                                            
                                            <tr v-for="t in targetSystems" :key="t.Id">
                                                <td style="padding:.6rem .3rem;">
                                                    <div>{{t.Name}}</div>
                                                    <div v-if="t.Kind != 'Email'">
                                                        <small class="text-muted">{{t.ExtraFields[0].Value}}</small>
                                                    </div>
                                                    <div v-else>
                                                        <small class="text-muted">                                        
                                                            <div v-for="item in t.ExtraFields"  :key="item.Key" class="row align-items-center">
                                                                <template v-if="item.Key == 'Kime'">
                                                                    <div class="col-12">
                                                                        <span>To:</span>
                                                                        <span style="margin-left:25px;">{{item.Value}}</span>
                                                                    </div>
                                                                </template>    
                                                                <template v-if="item.Key == 'Cc' || item.Key == 'Bcc' ">
                                                                    <div class="col-1">
                                                                        <label class="col-form-label">{{item.Key}}:</label>
                                                                    </div>
                                                                    <div class="col-11">
                                                                        <span>{{item.Value}}</span>
                                                                    </div>
                                                                </template>                                                                
                                                            </div>
                                                        </small>
                                                    </div>
                                                </td>
                                                <td style="vertical-align:middle;">
                                                    <div class="target-system-kind">{{t.Kind | targetSystemKind}}</div>
                                                    <small class="text-info" v-if="t.TotalFileSizeLimit && totalDocumentSize <= t.TotalFileSizeLimit">{{translate('max')}} {{t.TotalFileSizeLimit | prettyBytes}}</small>
                                                    <small class="text-danger" v-if="t.TotalFileSizeLimit && totalDocumentSize > t.TotalFileSizeLimit" :title="translate('warnings.fileSizeWarning')" style="cursor:help"><icon-exclamation-diamond/> {{translate('max')}} {{t.TotalFileSizeLimit | prettyBytes}}</small>
                                                </td>
                                            </tr>
                                            <tr v-for="t in data.AdditionalTargetSystems" :key="t.Name">
                                                <td>
                                                    <div>{{t.Name}}</div>
                                                    <small class="text-muted">
                                                    <div class="row align-items-center">
                                                         <div class="col-1">
                                                            <label class="col-form-label">To:</label>
                                                        </div>
                                                        <div class="col-11">
                                                            <span v-for="(mail, i) in t.To" :key="mail"><template v-if="i > 0">, </template>{{mail}}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="t.Cc"  class="row align-items-center">
                                                        <div class="col-1">
                                                            <label class="col-form-label">Cc:</label>
                                                        </div>
                                                        <div class="col-11">
                                                            <span v-for="(mail, i) in t.Cc" :key="mail"><template v-if="i > 0">, </template>{{mail}}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="t.Bcc"  class="row align-items-center">
                                                        <div class="col-1">
                                                            <label class="col-form-label">Bcc:</label>
                                                        </div>
                                                        <div class="col-11">
                                                            <span v-for="(mail, i) in t.Bcc" :key="mail"><template v-if="i > 0">, </template>{{mail}}</span>
                                                        </div>
                                                    </div>
                                                    </small>
                                                </td>
                                                <td style="vertical-align:middle;">
                                                    <div class="target-system-kind">{{t.Kind | targetSystemKind}}</div>
                                                    <small class="text-info">{{translate('draftPreview.jobSpecific')}}</small>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-5">
                    <div class="row justify-content-md-center">
                        <div class="col">
                            <h5>{{translate('circulationProfileSchema.steps')}}</h5>
                            <step-editor v-model="data.Steps" :user-list="userList" :editable="false"></step-editor>
                        </div>
                    </div>
                    
                </div>
        </div>
        <file-preview style="z-index: 999;" v-if="fileDetail" :file="fileDetail" :isOnlineView="onlineViewEnabled" :viewer="viewerType" @close="fileDetail=null;"></file-preview>
    </div>    
</template>

<script>
import stepEditor from '../components/StepEditor.vue'
import axios from 'axios'
import iconExclamationDiamond from '../components/Icons/exclamation-diamond.svg'

import FileDownloadLink from '../components/FileDownloadLink.vue'
import FilePreview from '../components/FilePreview.vue'
export default {
    data(){
        return{
            onlineViewEnabled: true,
            fileDetail: null,           // Önizlemesi görüntülenecek dosya
            viewerType: null,
        }
    },
    components: {
        stepEditor,
        iconExclamationDiamond,
        FileDownloadLink,
        FilePreview
    },
    props: {
        data: Object,
        userList: Array,
        targetSystemList: Array,
        categoryList: Array
    },
    created(){
        this.getOnlineViewPermission()
        .then(x => {
            this.onlineViewEnabled = x;
        }).catch(x => {
            console.warn("getOnlineViewPermission alınamadı:", x);
            this.onlineViewEnabled = true;
        });
    },
    computed: {
        totalDocumentSize(){
            if(!this.data.Documents || this.data.Documents.length == 0)
                return 0;

            return this.data.Documents.map(x => x.File.Size).reduce((accumulator, currentValue) => accumulator + currentValue);
        },
        totalFileSizeLimit(){
            return this.targetSystems.filter(x => x && x.TotalFileSizeLimit > 0).min(x => x.TotalFileSizeLimit)
        },
        totalAttachmentSize(){
            if(!this.data.Attachments || this.data.Attachments.length == 0)
                return 0;

            return this.data.Attachments.map(x => x.Size).reduce((accumulator, currentValue) => accumulator + currentValue);
        },
        targetSystems(){
            if(!this.data.TargetSystemIds || !this.targetSystemList)
                return [];

            return this.data.TargetSystemIds.map(x => this.targetSystemList.filter(t => t.Id == x)[0]).filter(x => x) || [];
        },
        hasRemTargetSystem(){
            return this.targetSystems.filter(x => x.Kind == 'Rem').length > 0;
        },
        categories(){
            return this.categoryList.filter(x => this.data.CategoryIds?.indexOf(x.Id) >= 0);
        },
        docType(){
            var docType = this.categories.map(x => x.Type).filter(x => x != 'General')[0];
            if(!docType)
                docType = 'General';
            return docType;
        }
    },
    methods: {
        showFilePreview(document, type, isFormatted) {
            document.EntityType = "Draft"
            this.fileDetail = document;
            this.viewerType = type;
            this.fileDetail.EntityId = this.data.Id;
            if(isFormatted)
                this.fileDetail.IsFormatted = true;
        },
        showAttachmentPreview(document, type, isFormatted) {
            document.EntityType = "Draft"
            document.IsAttachment = true
            this.fileDetail = document;
            this.viewerType = type;
            this.fileDetail.EntityId = this.data.Id;
            if(isFormatted)
                this.fileDetail.IsFormatted = true;
        },
        totfileSizeLimit(num){
            // jacked from: https://github.com/sindresorhus/pretty-bytes
            if (typeof num !== 'number' || isNaN(num)) {
                return num;
            }

            var exponent;
            var unit;
            var neg = num < 0;
            var units = ['B', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];

            if (neg) {
                num = -num;
            }

            if (num < 1) {
                return (neg ? '-' : '') + num + ' B';
            }

            exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
            num = (num / Math.pow(1024, exponent)).toFixed(2) * 1;
            unit = units[exponent];

            return (neg ? '-' : '') + num + ' ' + unit;
        },   
        downloadDocument(document){
            // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/draft/createDocumentUrl/`, {
                  EntityId : this.data.Id,
                  DocumentId: document.Id
              })
              .then(x => {
                console.log("createDocumentUrl Result:", x.data);
                window.open(x.data.Data.Url);
              })
              .catch(x => {
                  switch(x.response.status) {
                      case 404:
                        alert(this.translate('errors.noRecord'));
                        break;
                    default:
                        this.errorMessage = this.translate('errors.processFailed') + x;
                        break;
                  }
                  this.loading = false;
              });
        },
        downloadAttachment(attachment){
            // İndirilecek ek dosya için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/draft/createAttachmentUrl/`, {
                  EntityId : this.data.Id,
                  AttachmentId: attachment.Id
              })
              .then(x => {
                console.log("createAttachmentUrl Result:", x.data);
                window.open(x.data.Data.Url);
              })
              .catch(x => {
                  switch(x.response.status) {
                      case 404:
                        alert(this.translate('errors.noRecord'));
                        break;
                    default:
                        this.errorMessage = this.translate('errors.processFailed') + x;
                        break;
                  }
                  this.loading = false;
              });
        }
    }
}
</script>
<style scoped>
    table.ozet > tbody > tr > td:first-child {
        color:#666;
    }

    table.ozet > tbody > tr > td:nth-child(2) {
        font-weight: bold;
    }

    .target-system-kind {
        font-weight:bold; text-transform: uppercase;font-size:0.75rem;
    }
</style>